import React from 'react';
import styled from 'styled-components';

import { StarCheck } from 'src/assets/star-check';

import HoverImageGallery from './components/hover-image-gallery';
import { useCardContext } from './card-context';

/** Product image with optional staff pick overlay. Supports framed and full-width modes. */
export function CardImage(): JSX.Element {
  const { image, productName, fullWidthImages, isStaffPick } = useCardContext();

  const ImageWrapper = fullWidthImages ? ImageWrapperFullWidth : ImageWrapperFramed;
  const size = fullWidthImages ? 231 : 188;

  return (
    <ImageWrapper>
      <HoverImageGallery {...image} height={size} width={size} alt={`Image of ${productName} product`} />
      {isStaffPick && (
        <StaffPick>
          <StarCheck />
          Staff Pick
        </StaffPick>
      )}
    </ImageWrapper>
  );
}

const StaffPick = styled.div`
  align-items: center;
  background: #fff;
  border-bottom-right-radius: ${({ theme }) => theme.customized.radius.xs};
  color: ${({ theme }) => theme.customized.colors.staffPickTag};
  display: flex;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  left: 0;
  line-height: ${13 / 12};
  padding: 4px;
  position: absolute;
  text-transform: ${({ theme }) => theme.customized.textTransforms.tags};
  top: 0;
`;

const ImageWrapperFramed = styled.div`
  aspect-ratio: 1 / 1;
  margin-bottom: 8px;
  position: relative;

  img {
    display: block;
    margin: 0 auto;
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
`;

const ImageWrapperFullWidth = styled.div`
  aspect-ratio: 1 / 1;
  margin: -16px -16px 8px -16px;
  position: relative;
  border-top-left-radius: ${({ theme }) => theme.customized.radius.lg};
  border-top-right-radius: ${({ theme }) => theme.customized.radius.lg};
  overflow: hidden;

  img {
    display: block;
    margin: 0 auto;
    max-height: 100%;
    max-width: 100%;
    object-fit: cover;
  }

  ${StaffPick} {
    top: 16px;
    left: 16px;
  }
`;
